import selectInsurance from 'utils/selectInsurance';

const getConditionEmployment = ({ patient, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  if (selectedInsurance['Claim Filling Code'] && selectedInsurance['Claim Filling Code'].ID
    && selectedInsurance['Claim Filling Code'].ID === 2) {
    return 'Yes';
  }
  return 'No';
};

export default getConditionEmployment;



// WEBPACK FOOTER //
// ./src/utils/print/getConditionEmployment.js